import register from '@kpsys/angularjs-register';
import KpNewDocumentsComponent from './kp-new-documents.component';
import NewDocumentsDataService from '../../../features/record/new-documents.data-service';


export default register('portaro.features.record.kp-new-documents')
    .service(NewDocumentsDataService.serviceName, NewDocumentsDataService)
    .component(KpNewDocumentsComponent.componentName, KpNewDocumentsComponent)
    .name();
